import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import tours from "../../API/tours";
import "./TourDetails.css";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TourDetails = () => {
  const { tourName } = useParams();
  const tour = tours.find(
    (t) => t.name.replace(/\s+/g, "-").toLowerCase() === tourName.toLowerCase(),
  );

  const { addToCart } = useCart();

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isAdded, setIsAdded] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(
    tour?.variants[0] || { type: "Adult", price: tour?.price || 0 },
  );

  useEffect(() => {
    if (tour) {
      setSelectedVariant(
        tour.variants[0] || { type: "Adult", price: tour.price },
      );
    }
  }, [tour]);

  if (!tour) {
    return <p className="not-found">Tour not found!</p>;
  }

  const openLightbox = (index) => {
    setSelectedIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const showNext = (e) => {
    e.stopPropagation();
    setSelectedIndex((prevIndex) => (prevIndex + 1) % tour.imgArray.length);
  };

  const showPrev = (e) => {
    e.stopPropagation();
    setSelectedIndex(
      (prevIndex) =>
        (prevIndex - 1 + tour.imgArray.length) % tour.imgArray.length,
    );
  };

  const handleAddToCart = () => {
    console.log("handleAddToCart executed"); // Debugging log
    const selectedTour = {
      ...tour,
      name: `${tour.name} (${selectedVariant.type})`,
      price: selectedVariant.price,
      variant: selectedVariant.type,
    };
    addToCart(selectedTour);

    setIsAdded(true);

    setTimeout(() => {
      toast.success(`${tour.name} (${selectedVariant.type}) added to cart!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    }, 100);
    setTimeout(() => setIsAdded(false), 2000);
  };

  const handleVariantChange = (e) => {
    const selectedType = e.target.value;
    const variant = tour.variants.find((v) => v.type === selectedType);
    setSelectedVariant(variant);
  };

  return (
    <div className="tour-details-container">
      <img
        src={tour.imgArray[0]}
        alt={tour.name}
        className="tour-details-img"
        onClick={() => openLightbox(0)}
        loading="lazy"
      />
      {tour.imgArray.length > 0 && (
        <div className="image-gallery">
          {tour.imgArray.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`${tour.name} ${index + 1}`}
              className="gallery-thumbnail"
              onClick={() => openLightbox(index)}
              loading="lazy"
            />
          ))}
        </div>
      )}

      <div className="tour-details-content">
        <h1>{`${tour.name} (${selectedVariant.type})`}</h1>
        <span className="tour-details-price">
          {selectedVariant.price === null
            ? "Contact Us for pricing"
            : selectedVariant.price === 0
              ? "Free"
              : `₱ ${
                  Array.isArray(selectedVariant.price)
                    ? selectedVariant.price[0].price
                    : selectedVariant.price
                }`}
        </span>

        <span className="tour-details-rating">⭐ {tour.rating}</span>
        <span className="tour-details-days">{tour.days}</span>
        <div className="variant-selector">
          <label htmlFor="variant">Choose a package:</label>
          <select
            id="variant"
            value={selectedVariant.type}
            onChange={handleVariantChange}
          >
            {tour.variants.map((variant, index) => (
              <option key={index} value={variant.type}>
                {variant.type}
              </option>
            ))}
          </select>
        </div>

        {selectedVariant.type === "Kid (Add to cart as needed)" && (
          <div className="warning-message">
            ⚠️ Make sure you added Adult quantity first.
          </div>
        )}

        <p className="tour-details-desc">{tour.desc}</p>
        <button
          className="addToCart"
          onClick={handleAddToCart}
          disabled={isAdded}
        >
          {isAdded ? "Successfully Added!" : "Add to Cart"}
        </button>

        {tour.destinations && tour.destinations.length > 0 && (
          <>
            <h3>Destinations:</h3>
            <ul className="destination-list">
              {tour.destinations.map((destination, index) => (
                <li key={index}>{destination}</li>
              ))}
            </ul>
          </>
        )}

        {tour.itinerary && (
          <div className="itinerary">
            {tour.itinerary.map((dayItem) => (
              <div key={dayItem.day} className="itinerary__day">
                <h3>
                  Day {dayItem.day}: {dayItem.title}
                </h3>

                {dayItem.destinations.length > 0 && (
                  <ul className="destination-list">
                    {dayItem.destinations.map((place, index) => (
                      <li key={index}>{place}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        )}

        {tour.inclusions && tour.inclusions.length > 0 && (
          <>
            <h3>Inclusions:</h3>
            <ul className="destination-list">
              {tour.inclusions.map((inclusion, index) => (
                <li key={index}>{inclusion}</li>
              ))}
            </ul>
          </>
        )}

        {tour.exclusions && tour.exclusions.length > 0 && (
          <>
            <h3>Exclusions:</h3>
            <ul className="destination-list">
              {tour.exclusions.map((exclusion, index) => (
                <li key={index}>{exclusion}</li>
              ))}
            </ul>
          </>
        )}

        {tour.itineraryDay1 && tour.itineraryDay1.length > 0 && (
          <>
            <h3>Itinerary Day 1:</h3>
            <ul className="destination-list">
              {tour.itineraryDay1.map((itineraryDay1s, index) => (
                <li key={index}>{itineraryDay1s}</li>
              ))}
            </ul>
          </>
        )}
        {tour.itineraryDay2 && tour.itineraryDay2.length > 0 && (
          <>
            <h3>Itinerary Day 2:</h3>
            <ul className="destination-list">
              {tour.itineraryDay2.map((itineraryDay2s, index) => (
                <li key={index}>{itineraryDay2s}</li>
              ))}
            </ul>
          </>
        )}
        {tour.itineraryDay3 && tour.itineraryDay3.length > 0 && (
          <>
            <h3>Itinerary Day 3:</h3>
            <ul className="destination-list">
              {tour.itineraryDay3.map((itineraryDay3s, index) => (
                <li key={index}>{itineraryDay3s}</li>
              ))}
            </ul>
          </>
        )}
        {tour.itineraryDay4 && tour.itineraryDay4.length > 0 && (
          <>
            <h3>Itinerary Day 4:</h3>
            <ul className="destination-list">
              {tour.itineraryDay4.map((itineraryDay4s, index) => (
                <li key={index}>{itineraryDay4s}</li>
              ))}
            </ul>
          </>
        )}
        {tour.itineraryDay5 && tour.itineraryDay5.length > 0 && (
          <>
            <h3>Itinerary Day 5:</h3>
            <ul className="destination-list">
              {tour.itineraryDay5.map((itineraryDay5s, index) => (
                <li key={index}>{itineraryDay5s}</li>
              ))}
            </ul>
          </>
        )}
        {tour.itineraryDay6 && tour.itineraryDay6.length > 0 && (
          <>
            <h3>Itinerary Day 6:</h3>
            <ul className="destination-list">
              {tour.itineraryDay6.map((itineraryDay6s, index) => (
                <li key={index}>{itineraryDay6s}</li>
              ))}
            </ul>
          </>
        )}
        {tour.itineraryDay7 && tour.itineraryDay7.length > 0 && (
          <>
            <h3>Itinerary Day 7:</h3>
            <ul className="destination-list">
              {tour.itineraryDay7.map((itineraryDay7s, index) => (
                <li key={index}>{itineraryDay7s}</li>
              ))}
            </ul>
          </>
        )}

        <p className="tour-details-desc">{tour.longDescription}</p>

        <div className="tour-details-extra">
          {tour.duration && (
            <>
              <h3>Duration:</h3>
              <p>{tour.duration}</p>
            </>
          )}

          {tour.pickUpTime && (
            <>
              <h3>Drop & Pickup Service:</h3>
              <p>Pick-up time: {tour.pickUpTime}</p>
              <p>Leave your Hotel Information in the additional notes.</p>
            </>
          )}

          {tour.activities && tour.activities.length > 0 && (
            <>
              <h3>Activities:</h3>
              <ul className="destination-list">
                {tour.activities.map((activity, index) => (
                  <li key={index}>{activity}</li>
                ))}
              </ul>
            </>
          )}

          <h3>Payment:</h3>
          <ul className="payment-options">
            <li>– 50% upfront and 50% on arrival</li>
            <li>OR</li>
            <li>– Pay on Location</li>
          </ul>
        </div>
      </div>

      {lightboxOpen && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            &times;
          </button>
          <button className="lightbox-prev" onClick={showPrev}>
            &#10094;
          </button>
          <img
            src={tour.imgArray[selectedIndex]}
            alt="Preview"
            className="lightbox-image"
            loading="lazy"
          />
          <button className="lightbox-next" onClick={showNext}>
            &#10095;
          </button>
        </div>
      )}
    </div>
  );
};

export default TourDetails;
